import React from "react";
import Image from "./page-not-found.png";
const NotFound = () => {
  return (
    <div>
      <img src={Image} alt="Page Not Found" />
    </div>
  );
};
export default NotFound;
